module.exports = __webpack_public_path__ + "img/Stemness-SCC_GSE144240.600bcc6d.png";